import styled from '@emotion/styled';

export const OptionsContainer = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  padding: 0 8px;
  gap: ${props => props.gap ?? 8}px;
  flex: 1;
  overflow: auto;
`;

export const SearchBarContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 8px;
  background: #ffffff;
`;

export const SelectAllContainer = styled.div``;

export const FilterValueLabel = styled.div`
  position: sticky;
  top: 0;
  background: #ffffff;
  color: #737373;
  font-size: 14px;
  font-weight: 500;
  padding: 4px 0;
`;

export const CategoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
